'use strict';

var UserProfilePanelController = function UserProfilePanelController($scope, userSecureService, NavigationHistoryService, $stateParams, MomentService, UserPreferencesService) {
  $scope.userProfileState = $stateParams.transitionData;
  $scope.userData = userSecureService.getCurrentUser();
  $scope.$on('user-profile:change-screen', function onChangeScreen(event, value) {
    if (value === 'default') {
      $scope.$evalAsync(function () {
        userSecureService.loadUser().then(function () {
          $scope.userData = userSecureService.getCurrentUser();
          $scope.userProfileState = value;
          $stateParams.transitionData = value;
          UserPreferencesService.extendMomentConstants();
          MomentService.invalidateCache();
          NavigationHistoryService.saveState({
            screen: 'user-profile'
          });
        });
      });
    } else {
      $scope.userProfileState = value;
      $stateParams.transitionData = value;
    }
  });
};
UserProfilePanelController.$inject = ['$scope', 'UserSecureService', 'NavigationHistoryService', '$stateParams', 'MomentService', 'UserPreferencesService'];
module.exports = UserProfilePanelController;